{
  "title": "Borrowed Knowledge",
  "source": "Strixhaven: A Curriculum of Chaos",
  "levelAndSchool": "2nd-level Divination",
  "level": 2,
  "castingTime": "1 action",
  "range": "Self",
  "components": "V, S, M (a book worth at least 25 gp)",
  "duration": "1 hour",
  "description": [
    "You draw on knowledge from spirits of the past. Choose one skill in which you lack proficiency. For the spell's duration, you have proficiency in the chosen skill. The spell ends early if you cast it again."
  ],
  "spellLists": ["bard", "cleric", "warlock", "wizard"]
}
